import global from './global.json';
import alts from './alts.js';
export default {
    global,
    alts
};
